export { Provision } from "@pdfking/ghostscript/compatibility"
